var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button \xE2\x86\x92 SVG",
    clipPath: "url(#clip0_0_12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74 37C74 16.5655 57.4345 0 37 0C16.5655 0 0 16.5655 0 37C0 57.4345 16.5655 74 37 74C57.4345 74 74 57.4345 74 37Z",
    fill: "var(--fill-0, #F8FAFD)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4184 29.3959L45.1093 36.0877C45.6318 36.6102 45.6318 37.4575 45.1093 37.9801L38.4859 44.6035C37.9633 45.126 37.116 45.126 36.5935 44.6035C36.0709 44.0809 36.0709 43.2336 36.5935 42.7111L40.9325 38.372H29.4437C28.7046 38.372 28.1055 37.7729 28.1055 37.0339C28.1055 36.2948 28.7046 35.6957 29.4437 35.6957H40.9325L36.526 31.2883C36.0034 30.7657 36.0034 29.9185 36.526 29.3959C37.0486 28.8733 37.8958 28.8733 38.4184 29.3959Z",
    fill: "var(--fill-0, #003AD4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingArrow);
export default __webpack_public_path__ + "static/media/heading-arrow.61c6a407949ceeda85a4e4940c0a5447.svg";
export { ForwardRef as ReactComponent };